// extracted by mini-css-extract-plugin
export default {"PasswordResetEmail":"yw_a bhs_qt bhs_a bhs_w bhs_ea bhs_ti","PasswordResetEmail__title":"yw_b bhs_vp bhs_rg bhs_va","PasswordResetEmail__subtitle":"yw_c bhs_va"};